import { render } from "./DeliveryDetails.vue?vue&type=template&id=9b1dbe74"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/driveapp2.experimental.locatiers.fr/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__